import createSvgIcon from "./utils/create_icon"

const BoxOutline = createSvgIcon(<><g fill="currentColor"><path d="M7 16a1 1 0 0 1 1-1h3a1 1 0 1 1 0 2H8a1 1 0 0 1-1-1z" /><path clipRule="evenodd" d="M18.382 3a1 1 0 0 1 .894.553l1.618 3.236a1 1 0 0 1 .106.447V20a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V7.236a1 1 0 0 1 .106-.447l1.618-3.236A1 1 0 0 1 5.618 3zM5.236 7l1-2H11v2zM5 9v10h14V9zm8-2V5h4.764l1 2z" fillRule="evenodd" /></g></>, "BoxOutline")
export default BoxOutline
